import React from 'react';
import { stats } from '../data/hero';
export function Stats() {
  return <section aria-label="Results" className="border-y border-line bg-ink-2" data-id="element-297" data-mp="2wxq9bxqydsbk">
      <div className="mx-auto max-w-5xl px-5 py-8" style={{
      paddingBottom: "11px"
    }} data-id="element-298" data-mp="2wvm85nkfv7ez">
        <dl className="grid grid-cols-2 gap-6 sm:grid-cols-4" data-id="element-299" data-mp="2ixpd4vlmv92f">
          {stats.map(s => <div key={s.label} className="text-center" data-id="element-300" data-mp="2nvqsp6juoq95">
              <dt className="font-display text-4xl font-bold text-gold sm:text-5xl" data-id="element-301" data-mp="298e5zeib4eh6">{s.value}</dt>
              <dd className="mt-1 text-sm font-medium text-fog/65" data-id="element-302" data-mp="2dym5r4i6kqra">{s.label}</dd>
            </div>)}
        </dl>
        <p className="mx-auto mt-7 max-w-2xl border-t border-line pt-5 text-center text-[15px] text-fog/80" data-id="element-303" data-mp="207zhy7dykl9z">
          Get the complete 6-volume system and all 4 bonuses for{' '}
          <span className="font-bold text-teal" data-id="element-304" data-mp="1q99wy5qrmkpi">$27 USD</span> — one-time payment.
        </p>
      </div>
    </section>;
}